import Vue from "vue";

function Community() {
  Vue.util.defineReactive(this, "community", null);
}

Community.prototype.setCommunity = function (community) {
  this.community = community;
};

Community.prototype.hasCommunity = function () {
  return this.community != null;
};

export default new Community();



// WEBPACK FOOTER //
// ./src/services/Community.js